import styled from 'styled-components';

export const DashboardContainer = styled.div`
    padding: 20px;
`;

export const Navbar = styled.nav`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
`;

export const DataForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 15px; /* Adds space between all direct children */
    margin-bottom: 20px;
`;

export const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 15px;
    border: 1px solid #e9ecef;
    border-radius: 5px;
`;

export const Input = styled.input`
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 3px;
`;

export const Textarea = styled.textarea`
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 3px;
    min-height: 80px;
`;

export const Button = styled.button`
    padding: 10px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    align-self: flex-start; /* Aligns button to the start of the flex container */

    &:hover {
        background-color: #0056b3;
    }
`;

export const DropzoneContainer = styled.div`
    padding: 20px;
    border: 2px dashed #007bff;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    background-color: #f8f9fa;
    color: #007bff;

    p {
        margin: 0;
    }
`;

export const FileList = styled.ul`
    list-style: none;
    padding: 0;
    margin-top: 10px;
`;

export const FileListItem = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    border-bottom: 1px solid #eee;
`;

export const RemoveButton = styled.button`
    padding: 2px 8px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
`;

export const DataList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
`;

export const DataItem = styled.div`
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 10px;

    > p {
        margin: 0;
    }

    > h3 {
        margin-bottom: 0;
    }

    > img {
        width: auto;
        height: 100px;
        margin-top: 10px;
        object-fit: contain;
    }
`;

export const Image = styled.img`
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 5px;
`;

export const ImagePlaceholder = styled.div`
    width: 100px;
    height: 100px;
    background-color: #eee;
    border: 1px solid #ddd;
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
`;

export const PageButton = styled.button`
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    margin: 0 10px;
    cursor: pointer;
    border-radius: 5px;

    &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }
`;
